<template>
  <div>
    <v-dialog v-model="confirmDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('crudServicos.messages.systemMessage') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ this.mensagemdialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
            this.messageDismissButton }}</v-btn>
          <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
            this.messageConfirmButton }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <merus-data-table :headers="headers" :items="servicos" :search="search" :loading="loadingtable"
      :loading-text="$t('crudServicos.loading')" dense class="elevation-7"
      locale="pt" style="border-radius: 10px" :default-multi-sort="defaultSort"

 cod-tabela="SERVICOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar :title="$t('crudAtendimentoConfig.tabs.servicos')" :token="token" :items="servicos"
          csv-title="servicos" @search="search = $event">
          <template v-slot:add>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="6">
                          <v-select v-model="editedItem.id_tipo_ticket"
                            :items="tiposTickets"
                            item-text="nome_tipo_ticket"
                            item-value="id_tipo_ticket"
                            :label="$t('crudServicos.form.fields.tipoTicket')"
                            :rules="[tipoTicketRules]"
                            clearable
                            @change="onTipoTicketChange"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-select v-model="editedItem.id_tipo_atendimento"
                            :items="tiposAtendimentoFiltered"
                            item-text="nome_tipo_atendimento"
                            item-value="id_tipo_atendimento"
                            :label="$t('crudServicos.form.fields.tipoAtendimento')"
                            :rules="[tipoAtendimentoRules]"
                            :disabled="!editedItem.id_tipo_ticket"
                            clearable></v-select>
                        </v-col>
                      </v-row>
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field v-model="editedItem.nome_servico"
                            :label="$t('crudServicos.form.fields.nome')"
                            :rules="[nomeRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                            v-model="editedItem.id_checklists_equipamento"
                            :items="checklistsEquipamentos"
                            item-text="nome_checklist"
                            item-value="id_checklist_equipamento"
                            :label="$t('crudServicos.form.fields.checklistEquipamento')"
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            clearable
                            :menu-props="{ maxHeight: 300 }"
                          >
                            <template v-slot:selection="{ item }">
                              <v-chip small>{{ item.nome_checklist }}</v-chip>
                            </template>
                            <template v-slot:item="{ item }">
                              <span>{{ item.nome_checklist }}</span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                          <v-switch v-model="editedItem.ativo" class="ma-2"
                            :label="$t('crudServicos.form.fields.ativo')"
                            color="primary"></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-chip small :color="item.ativo === 1 || item.ativo === true ? 'green' : 'grey'" dark>
          {{ item.ativo === 1 || item.ativo === true ? $t('crudServicos.activeYes') : $t('crudServicos.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </div>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import EventBus from "../../utils/eventBus";
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    search: "",
    servicos: [],
    tiposAtendimento: [],
    tiposTickets: [],
    checklistsEquipamentos: [],
    editedIndex: -1,
    editedItem: {
      id_servico: null,
      id_tipo_atendimento: null,
      id_tipo_ticket: null,
      nome_servico: null,
      ativo: true,
      id_checklists_equipamento: [],
    },
    deletedItem: {
      id_servico: null,
      id_tipo_atendimento: null,
      id_tipo_ticket: null,
      nome_servico: null,
      ativo: null,
      id_checklists_equipamento: [],
    },
    defaultItem: {
      id_servico: null,
      id_tipo_atendimento: null,
      id_tipo_ticket: null,
      nome_servico: null,
      ativo: true,
      id_checklists_equipamento: [],
    },
  }),
  computed: {
    messageDismissButton() { return this.$t('button.dismiss'); },
    messageConfirmButton() { return this.$t('button.confirm'); },
    tiposAtendimentoFiltered() {
      if (!this.editedItem.id_tipo_ticket) return [];
      return this.tiposAtendimento.filter(
        (ta) => Number(ta.id_tipo_ticket) === Number(this.editedItem.id_tipo_ticket)
      );
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('crudServicos.form.title.create')
        : this.$t('crudServicos.form.title.edit');
    },
    defaultSort() {
      return [
        { value: 'nome_servico', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaServicos();
    this.populaTiposAtendimento();
    this.populaTiposTickets();
    this.populaChecklistsEquipamentos();
  },
  mounted() { },
  methods: {

    nomeRules() {
      if (!validador(this.editedItem.nome_servico, 1, 100, 1, 1)) {
        return this.$t('crudServicos.form.validation.nameRequired');
      }
      return true;
    },
    tipoAtendimentoRules() {
      if (this.editedItem.id_tipo_atendimento == null || this.editedItem.id_tipo_atendimento === '') {
        return this.$t('crudServicos.form.validation.tipoAtendimentoRequired');
      }
      return true;
    },
    tipoTicketRules() {
      if (this.editedItem.id_tipo_ticket == null || this.editedItem.id_tipo_ticket === '') {
        return this.$t('crudServicos.form.validation.tipoTicketRequired');
      }
      return true;
    },
    onTipoTicketChange() {
      this.editedItem.id_tipo_atendimento = null;
    },
    populaServicos() {
      apiController.request(apiController.endpoints.getallServicos, {
        onSuccess: (response) => {
          this.servicos = response.data;
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    populaTiposAtendimento() {
      apiController.request(apiController.endpoints.getallTiposatendimento, {
        onSuccess: (response) => {
          this.tiposAtendimento = response.data || [];
        },
      });
    },
    populaTiposTickets() {
      apiController.request(apiController.endpoints.getallTipostickets, {
        onSuccess: (response) => {
          this.tiposTickets = response.data || [];
        },
      });
    },
    populaChecklistsEquipamentos() {
      apiController.request(apiController.endpoints.getallChecklistsativos, {
        onSuccess: (response) => {
          this.checklistsEquipamentos = response.data || [];
        },
      });
    },
    editItem(item) {
      this.editedIndex = this.servicos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
      this.editedItem.id_tipo_ticket = item.id_tipo_ticket != null ? item.id_tipo_ticket : null;
      if (item.ids_checklists_equipamento != null) {
        this.editedItem.id_checklists_equipamento = typeof item.ids_checklists_equipamento === 'string'
          ? item.ids_checklists_equipamento.split(',').map((id) => Number(id.trim())).filter((id) => !isNaN(id))
          : Array.isArray(item.ids_checklists_equipamento) ? [...item.ids_checklists_equipamento] : [];
      } else {
        this.editedItem.id_checklists_equipamento = item.id_checklist_equipamento != null ? [item.id_checklist_equipamento] : [];
      }
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('crudServicos.messages.confirmDelete', { nome: item.nome_servico });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteServico, {
        data: { id_servico: this.deletedItem.id_servico },
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.id_checklists_equipamento = [];
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        const tipoAtendimento = this.tiposAtendimentoFiltered.find(
          (ta) => Number(ta.id_tipo_atendimento) === Number(this.editedItem.id_tipo_atendimento)
        );
        const tipoTicket = this.tiposTickets.find(
          (tt) => Number(tt.id_tipo_ticket) === Number(this.editedItem.id_tipo_ticket)
        );
        const descricao_tipo_atendimento =
          tipoAtendimento && tipoTicket
            ? `${tipoAtendimento.nome_tipo_atendimento} - ${tipoTicket.nome_tipo_ticket}`
            : null;
        const payload = {
          id_servico: this.editedItem.id_servico,
          id_tipo_atendimento: this.editedItem.id_tipo_atendimento,
          descricao_tipo_atendimento,
          nome_servico: this.editedItem.nome_servico,
          ativo: this.editedItem.ativo ? 1 : 0,
          id_checklists_equipamento: Array.isArray(this.editedItem.id_checklists_equipamento) ? this.editedItem.id_checklists_equipamento : [],
        };
        if (this.editedIndex === -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertServico, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateServico, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      const tipo = status ? "error" : "success";

      if (status) {
        if (this.operacao === 0) {
          mensagem = this.$t('crudServicos.messages.errorInclusion');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudServicos.messages.errorUpdate');
        } else {
          mensagem = this.$t('crudServicos.messages.errorDeletion');
        }
      } else {
        if (this.operacao === 0) {
          mensagem = this.$t('crudServicos.messages.includedSuccess');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudServicos.messages.updatedSuccess');
        } else {
          mensagem = this.$t('crudServicos.messages.deletedSuccess');
        }
        this.editedItem = Object.assign({}, this.defaultItem);
      }

      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaServicos();
    },
  },
};
</script>
